import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';

const SLayout = styled.div`
    text-align: center;
`;

const STextLayout = styled.div`
    margin-top: 20px;
`;

const LoadingIndicator = ({ className, style = {}, size = 30, text = '' }) => {
    const globalLoading = useSelector((state) => state.global.isGlobalLoadingShow);

    return (
        <SLayout className={className} style={style}>
            {!globalLoading && (
                <>
                    <CircularProgress size={size} />
                    {text && <STextLayout>{text}</STextLayout>}
                </>
            )}
        </SLayout>
    );
};

export default LoadingIndicator;
